import { render, staticRenderFns } from "./ConstructionWorkerShow.vue?vue&type=template&id=3503b3b0"
import script from "./ConstructionWorkerShow.vue?vue&type=script&lang=ts"
export * from "./ConstructionWorkerShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports